export enum CourseProgressStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  SAVED = 'saved',
}

export type CourseProgressResponse = {
  [CourseProgressStatus.IN_PROGRESS]: RawCourse[]
  [CourseProgressStatus.COMPLETED]: RawCourse[]
  [CourseProgressStatus.SAVED]: RawCourse[]
}

export type RawCourse = {
  course_uuid: string
  cmsgid: string
  uuid: string
  url: string
  small_image: string
  title: string
  introduction: string
  hours_per_week: string
  suitability: number
  duration_in_weeks: string
  has_certificates: string
  open_for_enrolment: string
  video_trailer?: string
  organisation: {
    name: string
    organisation_image: string
  }
  unlimited: string
  categories: string[]
  topics: string[]
  reviews: {
    average_score: string
    count: string
  }
  progress: {
    status: 'active'
    activated_at: string
    all_steps_completed_at: string | null
    comment_count: number
    deactivated_at: string | null
    last_commented_at: string | null
    last_visited_step_at: string
    steps_completed_count: number
    steps_completed_ratio: number
  }
}
